const env = process.env.REACT_APP_ENV ?? 'dev'
const version = process.env.REACT_APP_VERSION

const getVersion = () => {
  const environment = env.toUpperCase()

  switch (version) {
    case undefined:
      return `${environment}-UNKNOWN VERSION`
    case '0.0.0':
      return `${environment}-LOCALHOST`
    default:
      if (environment === 'DEV') {
        return `${environment}-build no. ${version.split('.')[2]}`
      } else {
        return `${environment}-v${version}`
      }
  }
}

export const config = {
  dev: {
    VERSION: getVersion(),
    DOMAIN_URL: '',
    SECURE_BASE_URL: 'https://supplierdatahub-3shku5ga.nw.gateway.dev',
    GOOGLE_CLIENT_ID: '297105321754-vc75b3ljt9c7g2dmbcrbkd6e5lt26hgv.apps.googleusercontent.com',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyDp5j7EDKaq7EyLlRD7FnpNT5iMl883DFE',
      authDomain: 'data-supplierdatahub-dev.firebaseapp.com',
      projectId: 'data-supplierdatahub-dev',
      storageBucket: 'data-supplierdatahub-dev.appspot.com',
      messagingSenderId: '297105321754',
      appId: '1:297105321754:web:617675216937299e1a06a3',
      measurementId: 'G-WHZRQDJMM2',
    },
    REPORTS_BUCKET: 'data-supplierdatahub-dev-temp-data-storage',
    DOCUMENTS_BUCKET_UNSCANNED: 'data-supplierdatahub-dev-sdh_documents',
    DOCUMENTS_BUCKET_CLEAN: 'data-supplierdatahub-dev-clean-sdh_documents',
    DOCUMENTS_BUCKET_QUARANTINED: 'data-supplierdatahub-dev-quarantined-sdh_documents',
    SUPPORT_MAIL: 'supplierdatahub@morrisonsplc.co.uk',
  },
  sit: {
    VERSION: getVersion(),
    DOMAIN_URL: '',
    SECURE_BASE_URL: 'https://sdh-80id3il2.nw.gateway.dev',
    GOOGLE_CLIENT_ID: '628023702998-49p6kgsf4d8b3nlqk881gkdpiq49o3jg.apps.googleusercontent.com',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyCOVGr9GGDc8CBpTjq2ksIFhirS0foi_cA',
      authDomain: 'data-supplierdatahub-sit.firebaseapp.com',
      projectId: 'data-supplierdatahub-sit',
      storageBucket: 'data-supplierdatahub-sit.appspot.com',
      messagingSenderId: '628023702998',
      appId: '1:628023702998:web:41f77ea6bf34a7af2aa077',
      measurementId: 'G-ZDSBYDX4M5',
    },
    REPORTS_BUCKET: 'data-supplierdatahub-sit-temp-data-storage',
    DOCUMENTS_BUCKET_UNSCANNED: 'data-supplierdatahub-sit-sdh_documents',
    DOCUMENTS_BUCKET_CLEAN: 'data-supplierdatahub-sit-clean-sdh_documents',
    DOCUMENTS_BUCKET_QUARANTINED: 'data-supplierdatahub-sit-quarantined-sdh_documents',
    SUPPORT_MAIL: 'supplierdatahub@morrisonsplc.co.uk',
  },
  uat: {
    VERSION: getVersion(),
    DOMAIN_URL: '',
    SECURE_BASE_URL: 'https://sdh-8d7t9vyk.nw.gateway.dev',
    GOOGLE_CLIENT_ID: '655683916556-4b4uptbj7c0hee4ljo8n5q6tbqb6hlj7.apps.googleusercontent.com',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyDzs7VcIikyf4MNVS4hXt9MRG4zvBrZs10',
      authDomain: 'data-supplierdatahub-uat.firebaseapp.com',
      projectId: 'data-supplierdatahub-uat',
      storageBucket: 'data-supplierdatahub-uat.appspot.com',
      messagingSenderId: '655683916556',
      appId: '1:655683916556:web:1a7035d267551f5229af29',
      measurementId: 'G-QZVVTP1MGJ',
    },
    REPORTS_BUCKET: 'data-supplierdatahub-uat-temp-data-storage',
    DOCUMENTS_BUCKET_UNSCANNED: 'data-supplierdatahub-uat-sdh_documents',
    DOCUMENTS_BUCKET_CLEAN: 'data-supplierdatahub-uat-clean-sdh_documents',
    DOCUMENTS_BUCKET_QUARANTINED: 'data-supplierdatahub-uat-quarantined-sdh_documents',
    SUPPORT_MAIL: 'supplierdatahub@morrisonsplc.co.uk',
  },
  prd: {
    VERSION: getVersion(),
    DOMAIN_URL: '',
    SECURE_BASE_URL: 'https://sdh-9r12spw3.nw.gateway.dev',
    GOOGLE_CLIENT_ID: '764115765267-tpqvh05pusjb8m0gm05q2v294f4or2hp.apps.googleusercontent.com',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyCf-TmtnT6S7nWEUCkW5lfKibx_cS4cwFk',
      authDomain: 'data-supplierdatahub-prd.firebaseapp.com',
      projectId: 'data-supplierdatahub-prd',
      storageBucket: 'data-supplierdatahub-prd.appspot.com',
      messagingSenderId: '764115765267',
      appId: '1:764115765267:web:4f6740cb09124d0ee657e6',
    },
    REPORTS_BUCKET: 'data-supplierdatahub-prd-temp-data-storage',
    DOCUMENTS_BUCKET_UNSCANNED: 'data-supplierdatahub-prd-sdh_documents',
    DOCUMENTS_BUCKET_CLEAN: 'data-supplierdatahub-prd-clean-sdh_documents',
    DOCUMENTS_BUCKET_QUARANTINED: 'data-supplierdatahub-prd-quarantined-sdh_documents',
    SUPPORT_MAIL: 'supplierdatahub@morrisonsplc.co.uk',
  },
}[env]
